import React from 'react';

export default function StaffPicksHeader() {
  return (
      <div className="hero-image-coll">
        <div className="hero-text-coll">
          <h2>Staff Favorites</h2>
        </div>
      </div>
  );
}
